export const strings = {
  orderConfirmed: "Order Confirmed",
  paymentThank:
    "Thank you, your payment has been successful. We will send  you a confirmation email in some time.",
  windowClose: "You may close this window now.",
};

export const HTML_ADS_DOMAIN = `https://${process.env.REACT_APP_TEMPO_BRANDS_URL}`;
